import { environment } from '@app/environments/environment';

const smid = environment.SALESMANAGO_SMID;
const isDevMode = process.env.NODE_ENV !== 'production';

export const SALES_MANAGO_SNIPPET = `
    var _smid = "${smid}";
    var _smapp = 1;
    var _smcsec = true;
    (function(w,r,a,sm,s){
        const _isDevMode = ${isDevMode};

        w['SalesmanagoObject'] = r;
        w[r] = w[r] || function(){ (w[r].q = w[r].q || []).push(arguments) };
        sm = document.createElement('script'); sm.type='text/javascript'; sm.async=true; sm.src=a;
        s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(sm, s);
        
        sm.onload = function() { 
            if (_isDevMode) {
                console.log('[SalesmanagoMS] Monitoring script loaded');

                // listen for Frontend SDK initialization event
                window.addEventListener('message', function(event) {
                    if (typeof event.data !== 'string' || !event.data.trim().startsWith('{')) return;

                    let data;
                    
                    try {
                        data = JSON.parse(event.data);
                    } catch {
                        console.warn('[SalesmanagoMS] Could not parse message data', event.data);
                        return;
                    }

                    if (data && data.topic === 'FRONTEND_SDK_STARTED' && window.SMApi && typeof window.SMApi === 'object') {
                        console.log('[SalesmanagoMS] Frontend SDK ready', { data, SMApi: window.SMApi });

                        if (window.sm && window.sm.api && typeof window.sm.api.pageStats === 'function') {
                            console.log('[SalesmanagoMS] PageStats:', window.sm.api.pageStats());
                        }
                    }
                });  
            }
        };
    })(window,'sm','https://www.salesmanago.pl/static/sm.js');
`;
